import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import Home from "./Components/Dashboard/Home";
import Dashboard from "./Components/Dashboard/Dashboard";
import Quotation from "./Components/Griha/Quotation";
import GrihaCustomerDetails from "./Components/Griha/CustomerDetails";
import HospicashQuotation from "./Components/Hospicash/Quotation";
import Leads from "./Components/Dashboard/Leads";
import HospicashCustomerDetails from "./Components/Hospicash/CustomerDetails";

const App = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<Home />} />
				</Route>
				<Route path="/Dashboard" element={<Layout />}>
					<Route index element={<Dashboard />} />
				</Route>
				<Route path="/Griha/Quotation" element={<Layout />}>
					<Route index element={<Quotation />} />
				</Route>
				<Route
					path="/Griha/Quotation/Customer-Details/:uid"
					element={<Layout />}
				>
					<Route index element={<GrihaCustomerDetails />} />
				</Route>

				<Route path="/Hospicash/Quotation" element={<Layout />}>
					<Route index element={<HospicashQuotation />} />
				</Route>
				<Route path="/Dashboard/Leads" element={<Layout />}>
					<Route index element={<Leads />} />
				</Route>
				<Route
					path="/Hospicash/Quotation/Customer-Details/:uid"
					element={<Layout />}
				>
					<Route index element={<HospicashCustomerDetails />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
};

export default App;
